// Module
var code = "<div class=\"logged_out sessions\"><sign-in-form ng-if=\"!institutionalSubdomain\" show-forgot-password=\"false\"></sign-in-form><div ng-if=\"institutionalSubdomain\" ng-click=\"loginWithSaml()\" class=\"center\" translate-once=\"front_royal_api_error_handler.logged_out.login_with_saml\" translate-compile></div></div>";
// Exports
export default code;